import { type SSRConfig } from '../../../types';

export const ssrSuccess = (
	ssr: SSRConfig | null,
): {
	'ssr:success': boolean;
} | null => {
	if (ssr?.getDoneMark()) {
		return { 'ssr:success': true };
	}

	return null;
};
